import React from 'react';

import Article from '~/app/components/blocks/Article.jsx';

const ArticlePreview = ({
  article,
  children,
}) => (
  <div className="container-fluid">
    {children}
    <Article article={article} disableTag />
  </div>
);

export default ArticlePreview;
